import React from "react";
import "./EinvoiceSteps.scss";
import { Link } from "react-router-dom";
import {
  EinvoiceApiRegistration,
  EinvoiceCreate,
  EinvoiceDashboard,
  EinvoiceEnterOtp,
  EinvoiceLogin,
  EinvoicePortal,
  GSTRStep1,
  GSTRStep2,
  GSTRStep3,
} from "../../assets/images";

type AppProps = {
  history: any;
};

const EinvoiceSteps = ({ history }: AppProps) => {
  const handleGoBack = () => {
    history.goBack();
  };
  return (
    <>
      <div
        className="einvoice-step-container"
        style={{ margin: 0, maxWidth: "100%" }}
      >
        <h1>Steps for E-Invoice API Access</h1>

        <div>
          <h2 className="einvoice-step-title">
            Step 1: Login to Your E-Invoice Account
          </h2>
          <p className="einvoice-step-description">
            Navigate to the{" "}
            <a
              href="https://einvoice1.gst.gov.in/"
              target="_blank"
              rel="noopener noreferrer"
              className="einvoice-link"
            >
              E-Invoice website
            </a>{" "}
            and log in with your <span className="highlight">Username</span> and
            <span className="highlight"> Password</span>. Click on
            <strong> Login Button</strong>.
          </p>
          <img
            src={EinvoiceLogin}
            alt="E-invoice login page"
            className="step-image"
          />
        </div>

        <div>
          <h2 className="einvoice-step-title mt-2">
            Step 2: Enter the Login Credentials
          </h2>
          <p className="einvoice-step-description">
            Enter username & password and click on login.
          </p>
          <img
            src={EinvoicePortal}
            alt="Einvoice Portal"
            className="step-image"
          />
        </div>

        <div>
          <h2 className="einvoice-step-title mt-3">
            Step 3: E-Invoice Portal Dashboard
          </h2>

          <p className="einvoice-step-description">
            Click on the <strong>Api Registration</strong> dropdown from left
            menu.
          </p>

          <img
            src={EinvoiceDashboard}
            alt="Einvoice Dashboard"
            className="step-image"
          />
        </div>

        <div>
          <h2 className="einvoice-step-title mt-3">
            Step 4: E-Invoice Create Api User
          </h2>

          <p className="einvoice-step-description">
            Creating an API user is a straight forward process that involves a
            few simple steps. Once you click on{" "}
            <strong>"Create API User"</strong>, the system will automatically
            initiate a verification process. An{" "}
            <strong>OTP (One-Time Password)</strong> will be sent to the
            registered mobile number associated with the account.
          </p>

          <p className="einvoice-step-description">
            Clicks on the verify OTP button then the user will be redirected to
            the API registration through GSP screen.
          </p>

          <img
            src={EinvoiceCreate}
            alt="Enable API Access (Image 1.2)"
            className="step-image"
          />

          <img
            src={EinvoiceEnterOtp}
            alt="Enable Enter Otp"
            className="step-image mt-3"
          />
        </div>

        <div>
          <h2 className="einvoice-step-title mt-3">
            Step 5: E-Invoice Api Registration
          </h2>

          <p className="einvoice-step-description">
            Select “Through GSP” and select your GSP{" "}
            <strong>“Quicko Infosoft Pvt. Ltd.”</strong> value from the dropdown
            menu and enter the username and password according to your
            preference and clicks on the submit button.
          </p>

          <img
            src={EinvoiceApiRegistration}
            alt="Einvoice Api Registration"
            className="step-image"
          />
        </div>

        <div>
          <h2 className="einvoice-step-title mt-3">
            Step 6: Now, the user can use this created GSP Username & Password
            for Authentication in FINAC
          </h2>
          .
        </div>
      </div>
    </>
  );
};

export default EinvoiceSteps;
